import * as React from 'react';

import {CueCard} from 'shells/cue-card/cue-card';
import {Modal} from 'shells/modal/modal';

import type {Webcast} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {getTimestampForWebcast} from '../../master-dashboard/dash-grid/cards/demio/get-timestamp-for-webcast';
import {UpcomingWebcasts} from '../../master-dashboard/dash-grid/cards/demio/upcoming-webcasts';

type Props = {
    webcasts: Webcast[];
};

export function UpcomingWebcastCueCard(props: Props) {
    const [isViewingModal, setIsViewingModal] = React.useState<boolean>(false);
    const onCloseModal = () => setIsViewingModal(false);

    if (!props.webcasts.length) {
        return null;
    }

    const registeredForWebcast = props.webcasts.find((webcast) => webcast.isCurrentUserRegistered);
    const isRegistered = Boolean(registeredForWebcast);

    const description = registeredForWebcast
        ? `You’re registered for ${registeredForWebcast.name} ${getTimestampForWebcast(
              registeredForWebcast
          )}`
        : 'Discover what makes Nutshell sneaky-powerful and get your questions answered by our team. We host these sessions several times a week!';

    return (
        <div className='mb-16'>
            <CueCard
                title='Tune in to a webcast'
                description={description}
                thumbnailPosition='full'
                thumbnailIllustration='/include/images/onboarding/jared.png'
                thumbnailBackgroundColor='yellow'
                cta={{
                    text: isRegistered ? 'Change your reservation' : 'Register',
                    onClick: () => setIsViewingModal(true),
                }}
                history={appHistory}
            />
            {isViewingModal ? (
                <Modal isOpen={true} maxWidth={480} maxHeight={500} onClose={onCloseModal}>
                    <UpcomingWebcasts
                        onClose={onCloseModal}
                        upcomingEvents={props.webcasts}
                        isChangingReservation={isRegistered}
                    />
                </Modal>
            ) : undefined}
        </div>
    );
}
